import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

let $collection = $('[data-slider="collection"]');
let $collectionNav = $collection.prev('.slider-nav-slides');
const log = debug("sliders:collection");

function setControls($sn, $arrow) {
  if ($('body').width() >= 768) {
    let newTop = ($collectionNav.height() / 2) + ($arrow.height() / 2);
    if ( newTop > 38 ) {
      $sn.css('top', newTop);
    }
  } else {
    $sn.css('top', 'auto');
  }
}

function sliderInit() {

  $collection.each(function () {
    let $this = $(this);

    let $slider = $this.slick({
      fade: true,
      slidesToShow: 1,
      lazyLoad: 'progressive',
      variableWidth: false,
      arrows: false,
      asNavFor: '.slider-nav-slides',
      initialSlide: 0
    });
    setTimeout(() => {
      $collection.slick('slickGoTo', 0);
    }, 200);

  });
  $collectionNav.each(function () {
    let $this = $(this);
    let $collectionImg = $this.closest('.slider-contain');
    let $sn = $collectionImg.find('.slider-nav');
    let $sb = $collectionImg.find('.slider-nav__arrows');
    let $arrow = '';
    let total = $this.children().length;
    let totalSlides = $collectionImg.find('.slider-collection__total');
    let theCurrentSlide = $collectionImg.find('.slider-collection__current');

    if (total < 10) {
      total = '0' + total;
    }
    totalSlides.text(total);
    let $sliderNav = $this.slick({
      mobileFirst: true,
      centerMode: true,
      centerPadding: '0px',
      slidesToShow: 1,
      variableWidth: true,
      lazyLoad: 'progressive',
      asNavFor: '.slider-for',
      arrows: true,
      appendArrows: $sb,
      adaptiveHeight: true,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: true,
            centerPadding: '60px',
            adaptiveHeight: false,
            initialSlide: 0
          }
        }
      ]
    });
    setTimeout(() => {
      $arrow = $sb.find('.slick-arrow');
      setControls($sn, $arrow);
      $collectionNav.slick('slickGoTo', 0);
    }, 200);

    $(window).on('resize', function () {
      setTimeout(() => {
        setControls($sn, $arrow);
      }, 100);
    }).on('load', function () {
      setControls($sn, $arrow);
    });

    $sliderNav.on('afterChange', function (event, slick, currentSlide, nextSlide) {
      setControls($sn, $arrow);

      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      if (($this.slick.slideCount - 1) == currentSlide) {
        setTimeout(function(){
          $this.slick.goTo(0);
        }, $this.slick.getOption('autoplaySpeed'));
      }

      if (i < 10) {
        i = '0' + i;
      }
      theCurrentSlide.text(i);
      
    });
  });
}

export function init() {
  if ($collection.length) {
    sliderInit();
    setTimeout(() => $collection.slick('slickGoTo', 0), 200);
  }
}

export default {
  init
};
